module.exports = __webpack_public_path__ + "img/f52f4348b533a9857f2b7eab3c27c2cc.7eb0482c.jpg";